import React from "react";
import { useEffect } from "react";
import Aos from "aos";
import { FaQuoteLeft } from "react-icons/fa";
export const Team = (props) => {
  useEffect(() => {
    Aos.init({ duration: 600 });
  }, []);
  return (
    <div id="team" className="pt-5  ">
      <div className=" bg-[#002e5b] ">
        <div data-aos="fade-up" data-aos-delay="100" className=" text-center ">
          <div className=" xs:p-10 md:p-10 flex flex-col items-center">
            <FaQuoteLeft className="text-white " />
            <p className="text-white py-8">
              We were looking for a company that was willing to supply molecular
              biology equipment during the covid pandemic and we were surprised
              that Matrix resources managed to get most of the orders that we
              were unable to source internationally due to the lockdown, we were
              happy they delivered
            </p>

            <h2 className="font-[700] text-white">
              - Saha diagnostics Djibouti -
            </h2>
          </div>
        </div>

        <div data-aos="fade-up" data-aos-delay="100" className=" text-center ">
          <div className="xs:p-10 md:p-10 flex flex-col items-center">
            <FaQuoteLeft className="text-white " />
            <p className="text-white py-8">
              Matrix Resouces has collaborated with local distributors to
              partner in offering storage facilities for our wide range of
              products such as cold rooms, vehicle showrooms, and Godowns where
              different products are handled according to manufacturer
              guidelines and specified standard operating procedures. we value
              ISO Certification and a high standard of quality checks and
              licenses.
            </p>

            <h2 className="font-[700] text-white">- Tebein ltd -</h2>
          </div>
        </div>
      </div>
    </div>
  );
};
